import { render } from "./ProjectTypes.vue?vue&type=template&id=c964802e&scoped=true"
import script from "./ProjectTypes.vue?vue&type=script&lang=js"
export * from "./ProjectTypes.vue?vue&type=script&lang=js"

import "./ProjectTypes.vue?vue&type=style&index=0&id=c964802e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c964802e"

export default script